import { Fragment } from "react";

/* MUI */
import { Grid, TextField, Typography } from '@material-ui/core';

const FormInputTextField = ({ label, required=false, size=4, ...otherProps }) => {
  return (
    <Fragment>
      <Grid item xs={size}>
        <Typography variant="h6" display='inline'>{label}</Typography>
        {required && <Typography variant="h6" display='inline' color='error'>*</Typography>}
      </Grid>

      <Grid item xs={12-size} align="center">
        <TextField
        required={required}
        fullWidth
        variant="outlined" {...otherProps} />
      </Grid>
    </Fragment>
  )
}

export default FormInputTextField;